module.exports = __webpack_public_path__ + "img/fiber.20b8c2da.webp";